import React from "react";
import PropTypes from "prop-types";
import Container from "./Container";

const ClassificationPageContainer = ({ containers = [] }) =>
    containers.map((container) => (
        <Container
            key={container.id}
            page="classification_page"
            container={container}
        />
    ));

ClassificationPageContainer.propTypes = {
    containers: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        }),
    ).isRequired,
};

export default ClassificationPageContainer;
